import { toast } from "react-toastify";

import { ConfigurationDto, OrganizationDto } from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { organizationsKeys } from "../queryKeys";

export const patchConfigurations = async (
  configurations: ConfigurationDto[]
): Promise<OrganizationDto> => {
  const resp = await api.patch<OrganizationDto>(
    "/v2/organizations/configurations",
    configurations
  );
  return resp.data;
};

export const usePatchConfigurations = (noToast?: boolean) => {
  const queryClient = useQueryClient();
  return useMutation<OrganizationDto, Error, any, any>({
    mutationKey: ["updateConfiguration"],
    mutationFn: async (data: ConfigurationDto[]) => patchConfigurations(data),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: organizationsKeys.one });
      void queryClient.invalidateQueries({
        queryKey: organizationsKeys.cartTransforms(data.id),
      });
      void queryClient.invalidateQueries({
        queryKey: organizationsKeys.metafield(data.id),
      });
      void queryClient.invalidateQueries({
        queryKey: organizationsKeys.cartTransforms(data.id),
      });
      !noToast && toast.success("Configuration Update Successful!");
    },
  });
};
